import React from 'react'
import Chart7 from '../Charts/Chart7'
import Table1 from '../Tables/Table1'
import PlantTable from '../Tables/PlantTable'
import LineTable from '../Tables/LineTable'
import Chart8 from '../Charts/Chart8'
import DGLive from '../hocs/DGLive'
import DGConsumption from '../hocs/DGConsumption'

const SensorFour = (props) => {
  const theme = props.theme;
  return (
    <div className="px-0 w-full">
      
   
      <div className=" flex    gap-5 gap-y-5 my-5">
        <PlantTable theme={props.theme}/>
        <LineTable theme={props.theme}/>
      </div>
          <div className="flex xl:flex-nowrap flex-wrap  justify-between bg-dark-echarts gap-5 gap-y-5 my-5">   
            {/* <DGLive   theme={props.theme} title='Production Data' />  */}
            <DGConsumption   theme={props.theme} title='Production Chart' />     
          </div> 
    </div>
  )
}

export default SensorFour